import app from 'flarum/common/app';

/** This extension's strings, by the part of the key after the extension id. */
export const t = (k, p) => app.translator.trans('ernestdefoe-velvet-rope.' + k, p);
flarum.reg.add('ernestdefoe-velvet-rope', 'common/t', { t: t, });